import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deletePollTemplateRequested } from 'features/polls/actions';

export function* deletePollTemplateSaga(action: ReturnType<typeof deletePollTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'deletePollTemplate', data: action.payload });
}
